// extracted by mini-css-extract-plugin
export var closeButton = "_gg-2";
export var closeButtonIcon = "_gg-3";
export var lightboxContent = "_gg-1";
export var lightboxOverlay = "_gg-0";